import React from "react";

export const LayoutEmpty = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};

export const getLayout = (page) => <LayoutEmpty>{page}</LayoutEmpty>;
